import { Injectable, Inject } from '@roai/framework';
import { IConfig, IStorage } from './adapter';
import Info from './info';
import { send } from './tracking';
import { reportCrash, reportError } from './monitor';

@Injectable()
class Core {
  private isRunning: boolean = false;
  private gdpr: boolean = false;

  public init(gdpr = false) {
    if (this.isRunning) {
      return;
    }
    this.isRunning = true;
    this.gdpr = gdpr;

    this.info.start(this.gdpr);
  }

  constructor(
    @Inject() private info: Info,
    @Inject('Config') private config: IConfig
  ) {}

  public stop() {
    this.isRunning = false;
    this.info.stop();
  }

  public async sendData(params: Record<string, string>, eventData) {
    const config = this.config;
    try {
      const deviceInfo = await this.info.getDeviceInfo();
      const commonInfo =  await this.info.getCommonInfo();
      const url = `${config.origin}${config.endpoints.report}`;
      send(url, {
        params,
        commonInfo,
        deviceInfo,
        eventData,
      }).then((result) => {
        if (result.success) {
          return;
        }
        reportError({
          logType: 'error',
          bizType: this.config.bizType,
          logName: 'request.error',
          params: {},
        });
        reportCrash({
          stackTrace: result.detail?.stack || result.detail?.message || '',
          customData: {
            _$: 'Core.request',
            ...result,
          },
          message: result.detail?.message || ''
        })
      });
    } catch (e) {
      reportError({
        logType: 'error',
        bizType: this.config.bizType,
        logName: 'getinfo.error',
        params: {},
      });
      reportCrash({
        stackTrace: e?.stack || e?.message || '',
        customData: {
          _$: 'Core.getInfo'
        },
        message: e?.message || '' 
      });
    }
  }
}

export type { IConfig, IStorage };

export { Core };
